import { StartDateActionTypes } from "../actions/types";
import { StartDateAction } from "../actions/startdate.actions";
import { initialState } from "../reducers/root.reducer";

export const startDateReducer = (
  state: string = initialState.startDate,
  action: StartDateAction
) => {
  switch (action.type) {
    case StartDateActionTypes.ADD_DATE:
      return action.payload;
    case StartDateActionTypes.RESET_DATE:
      return action.payload;
    default:
      return state;
  }
};
